module.exports = __webpack_public_path__ + "img/mp3.2a772814.png";